import * as React from 'react';
import { Component } from 'react';
import styled from 'react-emotion';
import SearchIcon from 'react-feather/dist/icons/search';
import placeholder from 'polished/lib/mixins/placeholder';
import rgba from 'polished/lib/color/rgba';
import match from 'match-sorter';
import flattenDeep from 'lodash/flattenDeep';
import { Docs } from 'docz';
import { get } from '@utils/theme';
import { getMenusFromDocs } from '@utils/getMenusFromDocs';
import { SearchCtxConsumer, } from './SearchContext';
export const SearchContext = React.createContext({});
const sidebarText = get('colors.sidebarText');
const Wrapper = styled('div') `
  background-color: #fff;
  display: flex;
  align-items: center;
  opacity: 1;
`;
const Icon = styled(SearchIcon) `
  stroke: ${sidebarText};
  width: 20px;
  opacity: 0.5;
`;
const Field = styled('div') `
  border: 1px solid ${p => rgba(sidebarText(p), 0.3)};
  box-shadow: 0 0px 2px ${p => rgba(sidebarText(p), 0.1)};
  border-radius: 4px;
  display: flex;
  align-items: center;
  padding-right: 10px;
  flex-basis: 100%;
`;
const Input = styled('input') `
  outline: none;
  width: 100%;
  padding: 8px 5px 8px 20px;
  background: transparent;
  border: none;
  font-size: 15px;
  line-height: 1.6;
  color: ${sidebarText};

  ${p => placeholder({
    color: rgba(sidebarText(p), 0.5),
})};
`;
class SearchInput extends Component {
    constructor() {
        super(...arguments);
        this.state = {
            lastVal: '',
        };
        this.match = (val, menu) => {
            const getItemsFromMenus = (menus) => {
                const items = [];
                const loop = (itemMenus) => {
                    itemMenus.forEach(menu => {
                        if (menu.items) {
                            items.push(menu.items);
                        }
                        if (menu.menus) {
                            loop(menu.menus);
                        }
                    });
                };
                loop(menus);
                return items;
            };
            const items = menu.map(item => {
                let items = [];
                const concat = (arr) => {
                    items = new Array().concat(items, arr);
                };
                if (!item.items && !item.menus) {
                    concat([item]);
                }
                if (item.items) {
                    concat(item.items);
                }
                if (item.menus) {
                    concat(getItemsFromMenus(item.menus));
                }
                return items;
            });
            const flattened = flattenDeep(items);
            return match(flattened, val, { keys: ['name'] });
        };
        this.search = (initial, menus, val) => {
            const change = !val.startsWith(this.state.lastVal);
            this.setState({ lastVal: val });
            return this.match(val, change ? initial : menus);
        };
        this.handleSearch = (initial, menus, val) => {
            const { setMenus, setSearching } = this.props;
            const isEmpty = val.length === 0;
            setMenus(isEmpty ? initial : this.search(initial, menus, val));
            setSearching(!isEmpty);
        };
    }
    render() {
        return (React.createElement(Docs, null, ({ docs }) => {
            const initial = getMenusFromDocs(docs, this.props.menuConfig);
            const menus = this.props.menus || initial;
            return (React.createElement(Wrapper, null,
                React.createElement(Field, null,
                    React.createElement(Input, { type: "text", placeholder: "Search...", onChange: (ev) => this.handleSearch(initial, menus, ev.target.value) }),
                    React.createElement(Icon, null))));
        }));
    }
}
const Search = () => (React.createElement(SearchCtxConsumer, null, props => React.createElement(SearchInput, Object.assign({}, props))));
export { Search };
//# sourceMappingURL=data:application/json;base64,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